import { useContext } from "react";

import { ScreenContext } from "ui/app";

export function useScreenContext() {
  return useContext(ScreenContext);
}
